import { useNavigate } from 'react-router-dom';

import { useMessages2 } from '../../hooks/useLanguage';
import DirectionButton from '../directionButton/direction-button';
import styles from './choose-header.module.css'

interface ChooseHeaderProps {
    title: string
    urlBack: string
}

const ChooseHeader = ({title, urlBack}: ChooseHeaderProps) => {

    const {messages} = useMessages2();
    const navigate = useNavigate()

    const onHandleBack = () => {
        navigate(urlBack);
    }
    
    return (
        <div className={styles.headerContainer}>
            <header className={styles.header}>
                <DirectionButton 
                    className={styles.button}
                    type='prev' 
                    text={messages?.intro_terug_button} 
                    onClick={onHandleBack}
                />
                <h2 className={styles.headerTitle}>
                    { title}
                </h2>
            </header>
        </div>
)}
export default ChooseHeader;
